import {
  SettingsDrillRow,
  SettingsGroup,
  SettingsPageFrame,
} from '@eluve/blocks';
import { GeneralTenantSettings } from '@eluve/frontend-feature-tenants';
import { FeatureFlaggedComponent } from '@eluve/smart-blocks';

export const OrganizationGeneralPage: React.FC = () => (
  <SettingsPageFrame title="Organization">
    <GeneralTenantSettings />
    <FeatureFlaggedComponent flag="LOCATIONS">
      <SettingsGroup title="Layers">
        <SettingsDrillRow
          title="Layers"
          description="Organize Eluve to best fit your practice."
          to="layers"
        />
      </SettingsGroup>
    </FeatureFlaggedComponent>
  </SettingsPageFrame>
);
